import { Link, Outlet, useParams } from '@tanstack/react-router';

import { EmptyState } from '../components/EmptyState';
import { useT } from '../i18n/provider';
import { useAuth } from '../stores/auth';

/**
 * El ámbito de empresa de `13 §2`, y el sitio donde el slug se convierte en id.
 *
 * El slug se resuelve contra la lista de empresas del token y no preguntando a
 * la API, porque esa lista es exactamente lo que quien llama tiene permitido
 * ver: un slug que no esté en ella produce el mismo «no encontrado» que
 * produciría la URL de un desconocido, sin ninguna petición que permita
 * distinguirlos.
 *
 * Aquí ya no hay navegación. Las veintiuna secciones que vivían en esta capa
 * como una fila de pestañas con scroll horizontal son ahora la barra lateral
 * (`routes/nav/CompanyNav`), donde caben y donde se leen; la cabecera con el
 * nombre de la empresa también sobra, porque el selector de la barra la dice.
 * Lo que queda es lo que esta capa siempre fue de verdad: una guarda.
 */
export function CompanyLayout() {
  const { companySlug } = useParams({ from: '/authenticated/c/$companySlug' });
  const company = useAuth((state) => state.user?.companies.find((c) => c.slug === companySlug));
  const t = useT();

  if (!company) {
    return (
      <EmptyState
        title={t('company.notAvailable')}
        description={t('company.notAvailableHint')}
        action={
          <Link to="/" className="text-sm font-semibold text-primary">
            {t('company.backToCompanies')}
          </Link>
        }
      />
    );
  }

  return <Outlet />;
}
